import React from "react"
import { motion } from "framer-motion"
import { LoaderCircle } from "lucide-react"
import { twMerge } from "tailwind-merge"
// import {  } from "lucide-react"

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg"
  color?: "primary" | "white" | "gray"
  text?: string
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  color = "primary",
  text,
  className = "",
}) => {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  }

  const colors = {
    primary: "text-legacy-blue",
    white: "text-white",
    gray: "text-gray-400",
  }

  return (
    <div className={twMerge("flex flex-col items-center justify-center space-y-2", className)}>
      <LoaderCircle className={twMerge(sizes[size], "animate-spin", colors[color])} />
      {text && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-sm text-legacy-light"
        >
          {text}
        </motion.p>
      )}
    </div>
  )
}

export default LoadingSpinner
